/* Aircraft preview: immutable art and garment only; no form, cart or network. */
(function(g){'use strict';
function esc(s){return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}
function n(v){return Math.round(v*100)/100;}
function App(){}
const Engine={render:function(D,code,subject,buyer,colour){
 if(D.version!=='r12f2')throw Error('Unsupported aircraft release');
 return g.HBR12F2.art(D,g.HBR12F2.scene(D,[subject.id,code,colour].join('/'),buyer));
}};
  App.prototype.garment = function (res, sh, msg, sleeveVal) {
    var D = this.D, S = this.S, T = D.tee, img = (this.cfg.imageBase || '') + (T.blank_prefix || 'hb-custom-aircraft-r12f2-g64-') + S.colour + '.jpg';
    var k = 1000 / 5000, pxin = T.blank_pxin_5000 * k, cx = 500, top = T.top_5000 * k;
    var vb = S.zoom ? n(cx - 6.6 * pxin) + ' ' + n(top - 0.8 * pxin) + ' ' + n(13.2 * pxin) + ' ' + n(13.2 * pxin) : '0 0 1000 1000';
    var body = '<image href="' + esc(img) + '" x="0" y="0" width="1000" height="1000" preserveAspectRatio="none"/>';
    var defs = '';
    if (res) {
      var aw = res.bb[2] - res.bb[0], sc = res.wIn * pxin / aw, x = cx - 6 * pxin + res.xIn * pxin, y = top + res.yIn * pxin;
      defs = res.defs;
      body += '<g transform="translate(' + n(x) + ' ' + n(y) + ') scale(' + sc.toFixed(6) + ') translate(' + n(-res.bb[0]) + ' ' + n(-res.bb[1]) + ')" opacity=".95">' + res.svg + '</g>';
    } else {
      body += '<rect x="' + n(cx - 6 * pxin) + '" y="' + n(top) + '" width="' + n(12 * pxin) + '" height="' + n(10 * pxin) + '" fill="none" stroke="#C8963E" stroke-dasharray="6 5" stroke-width="2"/>';
    }
    if(sleeveVal) throw Error('Sleeve not offered');
    var out = '<svg class="hbt-svg" viewBox="' + vb + '" role="img" aria-label="' + esc('Custom tee preview: ' + this.fam(S.design).label + ', ' + sh.name + (sh.placeholder ? '' : ' ' + sh.hull) + ', ' + D.inks[S.colour].name) + '" style="font-kerning:none;font-synthesis:none"><defs>' + defs + '</defs>' + body + '</svg>';
    if (msg) out += '<div class="hbt-blocked">' + esc(msg) + '</div>';
    return out;
  };
g.HBT={Engine:Engine,App:App};
})(window);
